class HeaderAnimate extends HTMLElement {
    constructor() {
      super();
      this.headerHeight = document.querySelector('sticky-header header');
      this.mainDetailsToggle = this.querySelector('details');
      this.summaryElements = this.mainDetailsToggle.querySelector('summary');
      this.content = this.summaryElements.nextElementSibling;
      this.currentURL = window.location.href;
      this.isHp = window.pageType == "index";
      // this.mainDetailsToggle.addEventListener('focusout', this.onFocusOut.bind(this, e));
      // this.mainDetailsToggle.addEventListener('toggle', this.onToggle.bind(this));
  
      this.animation = null;
      // Store if the element is closing
      this.isClosing = false;
      // Store if the element is expanding
      this.isExpanding = false;
      // Detect user clicks on the summary element
      this.summaryElements.addEventListener('click', (e) => this.onClick(e));
    }

    static get observedAttributes() {
      return ['data-action'];
    }

    // Only called for the disabled and open attributes due to observedAttributes
    attributeChangedCallback(name, oldValue, newValue) {
      if(name == "data-action"){
        if(oldValue == "open" && newValue == "close"){
          this.shrink(true);
        }
        if(oldValue == "open" && newValue == "close-fade"){
          this.shrink(false);
        }
      }
    }

    close(open = true) {
      if (open) {
        this.mainDetailsToggle.removeAttribute('open');
        this.mainDetailsToggle.querySelector('summary').setAttribute('aria-expanded', false);
      }
      this.stickyHeader = document.querySelector('sticky-header');
      if (this.stickyHeader.classList.contains('scrolled-up-past-header') || !this.stickyHeader.classList.contains('scrolled-up-past-header') && !this.stickyHeader.classList.contains('scrolled-past-header')) {
        this.stickyHeader.classList.remove('bg-text-color');
      } else {
        this.stickyHeader.classList.add('bg-text-color');
      }
      this.stickyHeader.classList.remove('mega-menu-trasparent');
      if (this.isHp) {
        this.logoNone = document.querySelector('.logo-selector');
        this.logoNone.classList.remove('mega-menu-logo-trasparent');
      }
      if(this.dataset.action == "open") this.dataset.action = "close";
      this.headerHeight.style.borderBottom = "0"; 
    }
  
    onClick(e) {
      // Stop default behaviour from the browser
      e.preventDefault();
      this.closeOtherMenu();
      // Add an overflow on the <details> to avoid content overflowing
      this.mainDetailsToggle.style.overflow = 'hidden';
      // Check if the element is being closed or is already closed
      if (this.isClosing || !this.mainDetailsToggle.open) {
        this.open();
      // Check if the element is being openned or is already open
      } else if (this.isExpanding || this.mainDetailsToggle.open) {
        this.shrink(true);
      }
    }
  
    shrink(animation) {
      this.mainDetailsToggle.style.overflow = 'hidden';
      // Set the element as "being closed"
      this.isClosing = true;
  
      // Store the current height of the element
      const startHeight = `0`;
      // Calculate the height of the summary
      const endHeight = `${this.content.offsetHeight}px`;

      this.header = document.querySelector('header');
      const headerHeight = `${this.header.offsetHeight}px`
      // If there is already an animation running
      if (this.animation) {
        // Cancel the current animation
        this.animation.cancel();
      }

      if(animation){
         // Start a WAAPI animation
        this.animation = this.content.animate({
          // Set the keyframes from the startHeight to endHeight
          height: [endHeight, startHeight],
          paddingTop: [endHeight, startHeight]
        }, {
          duration: 300,
          easing: 'ease-out'
        });
      }
      else{
        // Start a WAAPI animation for opacity
        this.animation = this.content.animate(
          {
            // Set the keyframes from fully visible (1) to hidden (0)
            opacity: [1, 0],
          },
          {
            duration: 300,
            easing: 'ease-out',
          }
        );
      }
      
      this.disableBlockScroll() 
      this.contentChild = this.content.querySelector('ul');
      this.contentChild.classList.remove('fade-in'); 
      this.close(false);
      
      // When the animation is complete, call onAnimationFinish()
      this.animation.onfinish = () => this.onAnimationFinish(false);
      // If the animation is cancelled, isClosing variable is set to false
      this.animation.oncancel = () => this.isClosing = false;
    }
  
    open() {
      // Apply a fixed height on the element
      // this.content.style.height = `${this.content.offsetHeight}px`;
      // Force the [open] attribute on the details element
      this.mainDetailsToggle.open = true;
      this.dataset.action = "open";
      // Wait for the next frame to call the expand function
      window.requestAnimationFrame(() => this.expand());
      this.headerHeight.style.borderBottom = "1px solid #e3e3e3"; 
    }
  
    expand() {
      // Set the element as "being expanding"
      this.isExpanding = true;
      // Get the current fixed height of the element
      const startHeight = `0`;
      // Calculate the open height of the element (summary height + content height + padding)
      const endHeight = `${this.content.offsetHeight}px`;

      this.header = document.querySelector('header');
      const headerHeight = `${this.header.offsetHeight}px`
      // If there is already an animation running
      if (this.animation) {
        // Cancel the current animation
        this.animation.cancel();
      }
      // Start a WAAPI animation
      this.animation = this.content.animate({
        // Set the keyframes from the startHeight to endHeight
        height: [startHeight, endHeight],
        paddingTop: [startHeight, endHeight]
      }, {
        duration: 300,
        easing: 'ease-out'
      });
      this.blockScroll();
      this.content.style.overflow = 'hidden';
      this.content.style.top = '0';
      this.contentChild = this.content.querySelector('ul');
      this.contentChild.classList.add('fade-out');
      setTimeout(() => {   
        this.contentChild.classList.add('fade-in'); 
      }, 100);
      this.stickyHeader = document.querySelector('sticky-header');
      this.stickyHeader.classList.add('bg-text-color');
      this.stickyHeader.classList.add('mega-menu-transition');
      this.stickyHeader.classList.add('mega-menu-trasparent');
      if (this.isHp) {
        this.logoNone = document.querySelector('.logo-selector');
        this.logoNone.classList.add('mega-menu-logo-trasparent');
      }
      
      // When the animation is complete, call onAnimationFinish()
      this.animation.onfinish = () => this.onAnimationFinish(true);
      // If the animation is cancelled, isExpanding variable is set to false
      this.animation.oncancel = () => this.isExpanding = false;
    
    }

    blockScroll() {
      this.main = document.querySelector('#overlay');
      this.body = document.querySelector('body');
      this.main.classList.add('tw-block');
      this.body.classList.add('tw-overflow-hidden');
    }

    disableBlockScroll() {
      this.main = document.querySelector('#overlay');
      this.body = document.querySelector('body');
      this.main.classList.remove('tw-block');
      this.body.classList.remove('tw-overflow-hidden');
    }
  
    onAnimationFinish(open) {
      // Set the open attribute based on the parameter
      this.mainDetailsToggle.open = open;
      // Clear the stored animation
      this.animation = null;
      // Reset isClosing & isExpanding
      this.isClosing = false;
      this.isExpanding = false;
      // Remove the overflow hidden and the fixed height
      this.mainDetailsToggle.style.height = this.mainDetailsToggle.style.overflow = ''
    }

    closeOtherMenu(){
      document.querySelectorAll("header-animate").forEach((el)=>{
        //set attribute true to other elements but not this
        if(!el.isEqualNode(this)){
          el.dataset.action = "close-fade";
        }
      })
    }
  }

  customElements.define('header-animate', HeaderAnimate);